import { isMobile } from 'react-device-detect';

import { theme } from 'shared/styles/theme';
import { Icon } from 'shared/ui/Icon';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

export const SurveyFinalContent = () => (
  <Flex alignItems='center' justifyContent='center' height='100%' gap={36}>
    <Flex
      backgroundColor={theme.colors.yellow800}
      borderRadius='50%'
      width={75}
      height={75}
      minWidth={75}
      minHeight={75}
      alignItems='center'
      justifyContent='center'
      border='2px solid black'
    >
      <Icon name='heart' width={36} height={36} />
    </Flex>
    <Flex flexDirection='column' gap={16}>
      <Typography fontSize={isMobile ? theme.fontSizes['24'] : theme.fontSizes['44']} fontWeight={theme.fontWeights.bold}>
        Спасибо, ты великолепен!
      </Typography>
      <Typography fontSize={isMobile ? theme.fontSizes['17'] : theme.fontSizes['24']}>
        Твоя обратная связь – это то, что поможет нам расти
      </Typography>
    </Flex>
  </Flex>
);
